module.exports = __webpack_public_path__ + "static/media/mens_11.95d5c4df.jpg";